import QRCode from "qrcode";
import { saveFile, readStoredFile } from "./blob-storage";

const QR_DIR = "storage/qrcodes";

export function patientUrlForSlug(slug: string, baseUrl?: string): string {
  const base = baseUrl ?? process.env.APP_BASE_URL ?? "http://localhost:3000";
  return `${base}/b/${slug}`;
}

export async function generateAndSaveQrCode(slug: string, baseUrl?: string): Promise<string> {
  const url = patientUrlForSlug(slug, baseUrl);
  const buffer = await QRCode.toBuffer(url, { type: "png", width: 512, margin: 2 });
  return saveFile({ localDir: QR_DIR, filename: `${slug}.png`, buffer, contentType: "image/png" });
}

export async function readQrCode(stored: string): Promise<Buffer> {
  return readStoredFile({ localDir: QR_DIR, stored });
}
